module.exports = __webpack_public_path__ + "static/img/left_bg.60b8e32.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/common/left_bg.png
// module id = qnZl
// module chunks = 7